import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BuyerModel } from 'src/models/buyer.model';
import {User} from "../../models/user.model";
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BuyerService {
  private buyerSubject: BehaviorSubject<BuyerModel>;
  public buyer$: Observable<BuyerModel>;

  constructor(private http: HttpClient) { 
    this.buyerSubject = new BehaviorSubject<BuyerModel>(null);
    this.buyer$ = this.buyerSubject.asObservable();
  }

  public get value(): BuyerModel {
    return this.buyerSubject.value;
  }

  set(buyer: BuyerModel): void {
    this.buyerSubject.next(buyer);
  }

  list(): Observable<Array<BuyerModel>> {
    return this.http.get(`${environment.apiUrl}buyer/`) as Observable<Array<BuyerModel>>;
  }

  currentBuyerInformation(): Observable<BuyerModel> {
    return this.http.get(`${environment.apiUrl}buyer/current_buyer_info/`)
    .pipe(tap(buyer => this.set(buyer as BuyerModel))) as Observable<BuyerModel>;
  }

  update(slug: string, value: any): Observable<BuyerModel> {
    return this.http.put(`${environment.apiUrl}buyer/${slug}/`, value)
    .pipe(tap(updatedBuyer => this.set(updatedBuyer as BuyerModel))) as Observable<BuyerModel>;
  }

  removeCollegue(slug: string): Observable<User> {
      return this.http.put(`${environment.apiUrl}buyer/remove_collegue/`, slug) as Observable<User>;
  }
}
